import { render } from "./actuVue.vue?vue&type=template&id=ea66671e"
import script from "./actuVue.vue?vue&type=script&lang=js"
export * from "./actuVue.vue?vue&type=script&lang=js"

import "./actuVue.vue?vue&type=style&index=0&id=ea66671e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__